import React from 'react';
import { BotChatContainer, BotChatMessage, BotMsgError, BotMsgMeta, BotMsgSection } from './styled';
import { CloseCircleOutlined } from '@ant-design/icons';

function ErrorInChat({error}) {
  return (
    <BotChatContainer>
      <BotMsgMeta>
        <h4>PromptAI</h4>
      </BotMsgMeta>

      <BotMsgSection>
        <BotChatMessage>
          <BotMsgError>
            <CloseCircleOutlined style={{color: '#FF4D4F', fontSize: 64,display: 'flex',alignItems: 'center',justifyContent: 'center'}} />
            <h4>{error.title}</h4>
            <p>{error.description}</p>
          </BotMsgError>
        </BotChatMessage>
      </BotMsgSection>
    </BotChatContainer>  
  )
}

export default ErrorInChat;